import { FC, MouseEvent } from "react";

import { AccountIcon } from "@theme/assets";
import { Button, DropdownMenu, Flex, MsLink, Spacer, ThemeUIStyleObject } from "@theme/components";
import { NavigationDataProps } from "@theme/types";

interface NavAccountDropdownProps {
  accountLabel: NavigationDataProps["accountLabel"];
  accountLinks: NavigationDataProps["accountLinks"];
  signOut: NavigationDataProps["signOut"];
  sx?: ThemeUIStyleObject;
  className?: string;
}

export const NavAccountDropdown: FC<NavAccountDropdownProps> = ({
  accountLabel,
  accountLinks,
  signOut,
  sx,
  className,
}) => {
  return (
    <DropdownMenu
      data-testid="nav-account-dropdown"
      buttonLabel={accountLabel}
      iconComponent={<AccountIcon sx={{ marginLeft: "0 !important", color: "grey300" }} />}
      aria-label="Account Dropdown"
      sx={{
        ...sx,
        zIndex: 1,
        'div[data-dropdown-menu="true"]': {
          right: 0,
        },
      }}
      className={className}
    >
      <>
        {accountLinks.map(({ to, label }) => {
          return (
            <Flex key={to} sx={{ px: "s300", py: "s100", m: "s100" }}>
              <MsLink
                variant="textLinkPrimary"
                sx={{ fontSize: "inherit", whiteSpace: "nowrap" }}
                to={to ?? ""}
              >
                {label}
              </MsLink>
              <Spacer space="s300" />
            </Flex>
          );
        })}
        <Flex sx={{ px: "s300", py: "s100", m: "s100" }}>
          <Button
            variant="link"
            onClick={(event: MouseEvent) => {
              event.preventDefault();
              signOut.action();
            }}
            sx={{ fontSize: "inherit" }}
          >
            {signOut.label}
          </Button>
        </Flex>
      </>
    </DropdownMenu>
  );
};
